import angular from 'angular';
import humanDate from 'human-date';

export default function humanWhen(Utils, $window) {
  'ngInject';

  return function link(scope, element, attrs) {
    let activeTimeout = null;
    let currentValue;

    function cancelTimer() {
      if (activeTimeout) {
        $window.clearTimeout(activeTimeout);
        activeTimeout = null;
      }
    }

    function toSeconds(date) {
      if (!date) {
        return false;
      }

      const compareTo = new Date();
      return Utils.subtractDates(compareTo, date) / 1000;
      // return (compareTo - date + (compareTo.getTimezoneOffset() - date.getTimezoneOffset()) * 60000) / 1000;
    }

    function updateTime() {
      element.text(humanDate.relativeTime(currentValue, { futureSuffix: '' }).toLowerCase());

      if (angular.isDefined(attrs.humanWhenEveryMinute)) {
        activeTimeout = $window.setTimeout(updateTime, 60 * 1000);
        return;
      }

      const howOld = toSeconds(currentValue);
      let secondsUntilUpdate = 3600;

      if (howOld < 60) {
        secondsUntilUpdate = 1;
      } else if (howOld < 3600) {
        secondsUntilUpdate = 60;
      }

      activeTimeout = $window.setTimeout(updateTime, secondsUntilUpdate * 1000);
    }

    scope.$watch(attrs.humanWhen, (value) => {
      cancelTimer();

      if (angular.isUndefined(value) || value === null || value === '') {
        if (currentValue) {
          element.text('');
          currentValue = null;
        }

        return;
      }

      currentValue = new Date(value);

      const oneSecondAgo = new Date();
      oneSecondAgo.setSeconds(oneSecondAgo.getSeconds() - 1);

      // prevent counting down from the future
      // set the timestamp to be at least one second ago
      if (currentValue > oneSecondAgo && !scope.$eval(attrs.allowFuture)) {
        currentValue = oneSecondAgo;
      }

      updateTime();
    });

    scope.$on('$destroy', () => {
      cancelTimer();
    });
  };
}
